import { Link } from 'react-router-dom';
import { useState } from 'react';
import axios from 'axios';
import ReusableDataTable from '../../components/ReusableDataTable';
import CertificateDetails from './certificate_details';
import BackdropModal from '../../components/modals/backdrop_modal';
import apiRequest from '../../services/apiService';

const pk = "cert_id";

const columns = [
    { id: 'id',                          field: 'cert_id',                       headerName: 'CertID' },
    { id: 'client_fullname',             field: 'client_fullname',               headerName: 'Client' },
    { id: 'relationship_to_beneficiary', field: 'relationship_to_beneficiary',   headerName: 'Relationship' },
    { id: 'beneficiary_fullname',        field: 'beneficiary_fullname',          headerName: 'Beneficiary' },
    { id: 'beneficiary_gender',          field: 'beneficiary_gender',            headerName: 'Gender' },
    { id: 'beneficiary_civil_status',    field: 'beneficiary_civil_status',      headerName: 'Civil Status' },
    { id: 'cert_type ',                  field: 'cert_type',                     headerName: 'Certificate' },
    { id: 'cert_purpose ',               field: 'cert_purpose',                  headerName: 'Purpose' },
    { id: 'created_at ',                 field: 'created_at',                    headerName: 'Date' },
];


// List of fields that are date fields
const columns_date = ['created_at'];


const actions = [
    { label: 'Edit', link: './update', icon: 'bx bx-edit-alt me-1' },

];

const other_actions = [
    // { label: 'View', link: '/delete', icon: 'bx bx-detail me-1' },
];

const fetchData = async ({ page, rowsPerPage, sortBy, sortOrder, searchTerm }) => {
    const params = {
        page     : page,
        page_size: rowsPerPage,
        ordering : sortBy ? `${sortOrder === 'desc' ? '-' : ''}${sortBy}`: undefined,
        search   : searchTerm || undefined,
    };

    return await apiRequest('GET', '/certificate/', null, params);
};

const CertificateTable = () => {

    const deleteEndpoint = `${process.env.REACT_APP_API_URL}/certificate`;
    const [selectedItem, setSelectedItem] = useState(null);

    const handleViewDetails = (item) => {
        console.log(item);
        setSelectedItem(item);
        setOpen(true);
    };

    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = () => {
        handleClose();
    };

    return (
        <>
            <ReusableDataTable
                fetchDataFn    = {fetchData}
                columns        = {columns}
                columns_date   = {columns_date}
                actions        = {actions}
                other_actions  = {other_actions}
                onViewDetails  = {handleViewDetails}
                deleteEndpoint = {deleteEndpoint}
                tableTitle     = 'List of Transactions'
                primarykey     = {pk}
            />

            <BackdropModal open={open} handleClose={handleClose} handleSave={handleSave} modalTitle="Certificate Print Preview" >
                <CertificateDetails selectedItem={selectedItem} />
            </BackdropModal>
        </>
    );
}

export default CertificateTable;